import {
  ComponentType,
  createContext,
  HTMLAttributes,
  ReactNode,
  useContext,
} from 'react';
import {
  Announcements as AnnouncementsBase,
  CancelDrop,
  DndContextProps,
  DragOverlayProps,
  DropAnimation,
  KeyboardCodes,
  AutoScrollOptions,
} from '@wix/patterns-dnd-kit-core';

export interface Announcements extends AnnouncementsBase {
  dragHandleLabel?: (id: string | number) => string;
  itemDescription?: (id: string | number) => string;
  listAttributes?: () => Partial<
    Pick<HTMLAttributes<HTMLElement>, 'aria-label'>
  >;
}

export interface IDragAndDropContext {
  onDragAndDropDisabledRowPointerDown?: (
    id: string | number,
    event: MouseEvent,
  ) => void;
  cancelDrop?: CancelDrop;
  dropAnimation?: DropAnimation;
  announcements?: Announcements;
  restoreFocus?: boolean;
  a11yContainer?: Element | null;
  onDragOver?: DndContextProps['onDragOver'];
  onDragMove?: DndContextProps['onDragMove'];
  eventHandlers?: {
    row?: (props: {
      id: string | number;
      disabled?: {
        draggable?: boolean;
        droppable?: boolean;
      };
    }) => Partial<HTMLAttributes<HTMLElement>>;
    handle?: (props: {
      id: string | number;
    }) => Partial<HTMLAttributes<HTMLElement>>;
  };
  keyboardCodes?: KeyboardCodes;
  consumers?: ReactNode;
  dragHandleRef?: (id: string | number, element: HTMLElement | null) => void;
  onDropAnimationEnd?: (
    id: string | number,
    ref: { current?: HTMLElement | null },
  ) => () => void;
  overlayWrapperElement?: ComponentType | DragOverlayProps['wrapperElement'];
  DragOverlayComponentType?: ComponentType<DragOverlayProps>;
  autoScrollOptions?: Partial<AutoScrollOptions>;
  hideOverlayBottomShadow?: boolean;
  useIsDropDisabled?: (id: string | number) => boolean;
  closestCenterOnViewPort?: boolean;
}

export const DragAndDropContext = createContext<IDragAndDropContext>({
  dropAnimation: {
    duration: 250,
    easing: 'cubic-bezier(0.33, 1, 0.68, 1)',
  },
});
export const useDragAndDropContext = () => useContext(DragAndDropContext);
